<script setup lang="ts">
defineProps<{
  block: BlockSummary,
  noHorizontalPadding?: boolean,
}>()
</script>

<template>
  <section class="container-d my-3" :class="{ 'px-1': !noHorizontalPadding }">
    <h2 v-if="block.label" class="label">
      {{ block.label }}
    </h2>

    <core-rich-text 
      v-if="hasRichTextContent(block.description)" 
      :content="block.description" 
      class="mb-1" 
      text-size-class="text-d" 
    />

    <template v-if="block.viewOption === 'list'">
      <ul>
        <li
          v-for="item in block.summaryItems"
          :key="item.id"
          class="list-sep border-current first:b-t-current first:border-current flex flex-col gap-0"
        >
          <p v-if="item.label" class="text-sm">{{ item.label }}</p>
          <core-rich-text v-if="hasRichTextContent(item.richText)" :content="item.richText" text-size-class="text-sm" />
        </li>
      </ul>
    </template>

    <PageAccordion v-else :multiple="block.multipleOpenAtOnce ?? false">
      <template #content="{ activeId }">
        <PageAccordionItem
          v-for="item in block.summaryItems"
          :key="item.id"
          :item="{ value: item.id, label: item.label }"
          :active-id="activeId"
        >
          <template #content>
            <core-rich-text v-if="hasRichTextContent(item.richText)" :content="item.richText" text-size-class="text-sm" />
          </template>
        </PageAccordionItem>
      </template>
    </PageAccordion>
  </section>
</template>
